import { useEffect, useState } from 'react';
import './App.css';
import 'react-tooltip/dist/react-tooltip.css';
import { ToastContainer } from 'react-toastify';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Auth0Provider, AuthorizationParams } from "@auth0/auth0-react";
import * as Utils from "./modules/Utils";
import Secure from './components/app/auth/Secure';
import { IAuthConfig, getConfig } from './modules/auth/AuthApi';
import ModalContainer from './components/app/Modal/ModalContainer';
import { PermissionProvider } from './modules/auth/Permissions/PermissionContext';
import { MainConfigProvider } from './modules/config/MainConfigContext';
import * as Navigation from "./modules/Navigation";
import MessageBrokerClient from "./components/app/MessageBrokerClient";

function App() {
  const [authConfig, setAuthConfig] = useState<IAuthConfig>({} as IAuthConfig);
  const [ready, setReady] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    async function getAuthConfig() {
      const result = await getConfig();
      setAuthConfig(result);
      setReady(true);
    }

    getAuthConfig();
  }, [])

  function getRedirectUri() {
    // Redirect to root, DashboardPage will handle navigation to first accessible page based on permissions
    return `${window.location.origin}/`;
  }

  // Ensure offline_access is included in scope for refresh tokens
  function getScope(): string {
    const scope = authConfig.scope || '';
    const scopes = scope.split(' ').filter(s => s.trim());
    if (!scopes.includes('offline_access')) {
      scopes.push('offline_access');
    }
    return scopes.join(' ');
  }

  const authorizationParams: AuthorizationParams = {
    redirect_uri: getRedirectUri(),
    audience: authConfig.audience,
    scope: getScope(),
    connection: authConfig.connection
  };

  return (ready === true ?
    <>
      <Auth0Provider 
        domain={authConfig.domain} 
        clientId={authConfig.clientId}
        authorizationParams={authorizationParams}
        cacheLocation="localstorage"
        useRefreshTokens={true}
      >
        <Secure>
          <PermissionProvider >
            <MainConfigProvider>
              <>
                <ModalContainer />
                <ToastContainer autoClose={3000} />
                <MessageBrokerClient />
                <Outlet />
              </>
            </MainConfigProvider>
          </PermissionProvider>
        </Secure>
      </Auth0Provider>
    </> : <></>
  );
}

export default App;